import { Platform } from '@angular/cdk/platform';
import { ChangeDetectorRef, Component, inject, Input, OnInit, Optional } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountType } from '@collections/companies/enums/company.enums';
import { ICompany } from '@collections/companies/interfaces/company.interface';
import { RequestTypeEnum } from '@collections/request-info/enums/request-info.enums';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserInfo } from 'app/shared/services/users/types/user-info';
import { UsersService } from 'app/shared/services/users/users.service';
import { AnalyticsService } from 'app/shared/services/google-tag-manager/analytics/analytics.service';
import { StandService } from 'app/stand/stand.service';
import { switchMap, tap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'info-bar-base',
  template: ``,
  styles: []
})
export class InfoBarBaseComponent implements OnInit {
  public user: UserInfo;
  company: ICompany;
  isShowNumber = false;
  accountType = AccountType;

  requestType = RequestTypeEnum;
  isFollowedCompany: boolean = false;
  platform = inject(Platform);
  cd = inject(ChangeDetectorRef);
  standService = inject(StandService);
  analyticsService = inject(AnalyticsService, { optional: true });
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  usersService = inject(UsersService);

  ngOnInit(): void {
    if (this.platform.isBrowser) {

      this.standService.getCurrentCompany()
      .pipe(
        tap(c => this.company = c),
        switchMap(() => this.usersService.onUserChange),
        untilDestroyed(this)
      )
      .subscribe(async (user) => {
        this.user = user;
        this.isFollowedCompany = user ? this.usersService.isFollowedCompany(this.company._id): false;
      });
    } else {
      this.standService.getCurrentCompany().subscribe(company => this.company = company);
    }
  }

  showTelephonNumber(): void {
    this.analyticsService.trackCustomEvent('stand_click_call');
    this.checkPermission(() => this.isShowNumber = !this.isShowNumber);
  }

  callTelephonNumber(): void {
    this.checkPermission(() => window.open('tel:'+ this.company.contacts[0].telephone, '_self'));
  }

  getDirection(): void {
    this.analyticsService.trackCustomEvent('stand_click_directions');
    this.checkPermission(() => this.user)
    if (this.user) {
      const a = this.company.addresses[0];
      const url = `http://maps.google.com/?q=${a.street},${a.city},${a.region},${a.countryCode}`;
      window.open(url, '_blank');
    }
  }

  openWebsite(): void {
    this.analyticsService.trackCustomEvent('stand_click_website');
    this.checkPermission(() => this.user)
    if (this.user)
      window.open(this.company.webSite, '_blank');
  }

  openRequestInfo(requestType: RequestTypeEnum): void {
    this.analyticsService.trackCustomEvent(`stand_click_${requestType}`);
    //this.checkPermission(() => this.router.navigate(['./request-info-company', requestType], {relativeTo: this.activatedRoute}));
    this.router.navigate(['./request-info-company', requestType], {relativeTo: this.activatedRoute})
  }

  openRequestInfoMobile(requestType: RequestTypeEnum): void {
    this.analyticsService.trackCustomEvent(`stand_click_${requestType}`);
    //this.checkPermission(() => this.router.navigateByUrl(`hall${this.company.primaryPath}/stand/${this.company.slug}/request-info-company/message`));
    this.router.navigateByUrl(`hall${this.company.primaryPath}/stand/${this.company.slug}/request-info-company/message`)
  }
  
  checkPermission(cb: Function): void {
    this.usersService.checkPermission(cb);
  }

  toggleFollowedCompany(): void {
    this.usersService.toggleFollowCompany(this.company, () => this.cd.detectChanges());
  }

}
